import Image from "@Components/Image";
import CookiesPopUp from "@Components/cookies/CookiesPopUp";
import EmailSubscribeBox from "@Components/email-subscribe-box";
import { CMSImageType } from "@Types/Contentful";
import { ICookiesPopUpProps } from "@Types/CookiesPopUp";
import footerClasses from "@wff/styles/snippets/_footer.module.scss";
import { FooterLinks } from "./FooterLinks";
import footerMenuStyles from "./Footer.module.scss";

export type menuItem = {
  title: string;
  subMenus?: {
    items: menuItem[];
  };
  link: string;
  icon: CMSImageType;
};

type ImageType = {
  url: string;
  width: number;
  height: number;
  title: string;
  description?: string;
};

type SocialMedia = {
  image: ImageType;
  url: string;
};
export interface footerProps {
  footerMenus: {
    items: menuItem[];
  };
  emailSignupTitle: string;
  emailSignupCaption: string;
  emailSignupTextBoxPlaceholder: string;
  emailSignupButtonLabel: string;
  socialTitle: string;
  instagramUrl: string;
  facebookUrl: string;
  socialMedias: {
    items: [SocialMedia];
  };
  cookiesPopUp: ICookiesPopUpProps;
  copyRightsContent: string;
  isCookieModelOpen: Function;
}

export function Footer(props: footerProps) {
  const {
    footerMenus,
    emailSignupTitle,
    emailSignupCaption,
    emailSignupTextBoxPlaceholder,
    emailSignupButtonLabel,
    socialTitle,
    socialMedias,
    cookiesPopUp,
    copyRightsContent,
    isCookieModelOpen,
  } = props;
  const menus = footerMenus?.items ?? [];

  return (
    <footer className={`${footerClasses.layout__footer} section`}>
      <div className={`layout__footer ${footerClasses["site-footer"]}`}>
        <article className={footerClasses["site-footer__grid"]}>
          <EmailSubscribeBox
            emailSignupTitle={emailSignupTitle}
            emailSignupCaption={emailSignupCaption}
            emailSignupTextBoxPlaceholder={emailSignupTextBoxPlaceholder}
            emailSignupButtonLabel={emailSignupButtonLabel}
          />
          <section
            className={`${footerClasses["site-footer__store"]} ${footerClasses["site-footer__store--delivery-only"]}`}
          >
            <div className={footerMenuStyles["social-title"]}>
              <h2>{socialTitle}</h2>
            </div>
            <div className={footerMenuStyles["social-icons"]}>
              {socialMedias?.items?.map((socialMedia, index: number) => {
                return (
                  <a
                    key={index}
                    href={socialMedia?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`social-media-${index}`}
                  >
                    <Image
                      src={
                        socialMedia?.image?.url &&
                        `${socialMedia.image.url}?fm=webp&w=100&h=100`
                      }
                      alt={socialMedia?.image?.title}
                      layout="intrinsic"
                      height={40}
                      width={40}
                    />
                  </a>
                );
              })}
            </div>
          </section>
        </article>
        <FooterLinks menus={menus} />
        <section className={footerClasses["site-footer__copyright"]}>
          {copyRightsContent}
        </section>
        <CookiesPopUp {...cookiesPopUp} isCookieModelOpen={isCookieModelOpen} />
      </div>
    </footer>
  );
}

Footer.defaultProps = {
  footerMenus: {},
  emailSignupTitle: "",
  emailSignupCaption: "",
  emailSignupTextBoxPlaceholder: "",
  emailSignupButtonLabel: "",
  socialTitle: "",
  instagramUrl: "",
  facebookUrl: "",
  socialMedias: [],
};

export default Footer;
